import { useEffect, useCallback, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import ReactApiService from '../../services/reactApiService'

const useStyles = makeStyles((theme) => ({
	root: {
	},	 
	aboutTitle: {
		fontSize: '1.2em',
		fontWeight: '600',
	},
	aboutContent: {
		fontSize: '2em',
		margin: '2em auto',
		width: '800px'
	}
}));

export default function InterfaceSwitcher(props) {
	
	const classes = useStyles();
  const [values, setValues] = useState({
    contentLoaded: false,
		reloadMessage: 'Updating option ...'
  });
	console.log( 'props ::', props);
	// keep function reference.
  const getContent = useCallback(() => {
		if ( props.mode !== 'production' ) {
			setValues({ 
				...values,
				'contentLoaded': true, 
				'reloadMessage': values.reloadMessage+' '+props.mode
			});
			return;
		}
		
		const dataService = new ReactApiService();
		dataService.post({endpoint:'switchInterface',body:{optionKey:props.optionKey,value:'1'}})
			.then( 
				(response) => {
					setValues({
						...values, 
						'contentLoaded': true, 
						'reloadMessage': response.message 
					});
				},
				(error) => {}
			).then( () => {
				window.location.reload();
			})
  }, [props, values]) 	
	
	useEffect(() => {
		if ( ! values.contentLoaded ) {
			getContent()
		}
	},[values.contentLoaded, getContent]);

  return (
		<>
			<div className={classes.aboutContent} dangerouslySetInnerHTML={{__html: values.reloadMessage}}></div>
		</>
  );
}
